import config from "@/common/config.js"
import OSSUtil from "./Upload_2_OSS/ossUtil.js";
import axios from '../../config/http.js'
import OSS from 'ali-oss'
class Uploader {
	constructor() {}

	async uploadMaterial(file, callback) {
		let canInit = false;
		if (!config.ossConfig.securityToken) {
			const ossConfig = localStorage.getItem('ossConfig');
			if (ossConfig) {
				config.ossConfig = JSON.parse(ossConfig);
			}
		}
		if (!config.ossConfig.securityToken) {
			//为空，需要初始化
			canInit = true;
		} else {
			let now = Date.parse(new Date());
			let end = config.ossConfig.endTime;
			if (end < now) {
				//需要初始化
				canInit = true;
			}
		}
		if (canInit) {
			let _this = this;
			axios({
				method: 'GET',
				url: '/material/getAcsResponse',
				data: {},
			}).then(async res => {
				config.ossConfig = res.data.data
				let now = Date.parse(new Date());
				config.ossConfig.endTime = now + config.ossConfig.expiration * 1000;
				//持久化
				localStorage.setItem('ossConfig', JSON.stringify(res.data.data));
				await this.doUploadMaterial(file, callback);
			}).catch(function(error) {
				console.log(error);
			});
		} else {
			await this.doUploadMaterial(file, callback);
		}
	}

	async doUploadMaterial(file, callback) {
		var datas = [];
		let data = await this.mpUpload2oss(file);
		if (data.hash instanceof Array) {
			if (data.hash.length > 0) {
				data.hash = data.hash[0]
			} else {
				data.hash = ''
			}
		}
		datas.push(data);
		axios({
			method: 'POST',
			url: '/material/create',
			data: datas,
		}).then(response => {
			if (callback) {
				response.data.data.forEach((materialId, index) => {
					callback({
						materialId: materialId,
						url: datas[index].tempUrl
					});
				});
			}
		}).catch(function(error) {
			console.log(error);
		});
		//上传到素材库
	}


	async mpUpload2oss(option) {
		return new Promise(async (resolve, reject) => {
			let client = new OSS({
				region: "oss-cn-beijing",
				secure: true,
				endpoint: config.ossConfig.endpoint,
				accessKeyId: config.ossConfig.accessKeyId,
				accessKeySecret: config.ossConfig.accessKeySecret,
				stsToken: config.ossConfig.securityToken,
				bucket: "car-help"
			});
			let file = option.file
			console.log(file)
			let name = OSSUtil.getFileName(file.name);
			let suffix =  OSSUtil._getSuffix(file.name);
			let key =  config.ossConfig.fileStart +"/"+name+suffix;
			
			  const options = {
			  	progress: async function(p) {
			  		let e = {};
			  		e.percent = p * 100;
			  		option.onProgress(e)
			  	},
			  	parallel: 1,
			  	partSize: 1024 * 1024*10,
			  };

			console.log(config.ossConfig)
			await client.multipartUpload(key, file, options).then(result => {
				var res=result.res;
				var hash=res.headers.etag?res.headers.etag:result.etag
				let ret = {
					url: config.ossConfig.ossHost+"/"+result.name,
					hash:hash,
					size:file.size,
					fullName:file.name,
					name:name,
					nameSuffix:suffix,
					type:'image',
					tempUrl:config.ossConfig.ossHost+"/"+result.name
				}
				resolve(ret)
			}).catch(err => {
				console.error('上传出错了', err);
				reject();
			});
		})
	}
}


export default new Uploader();



// WEBPACK FOOTER //
// ./src/common/uploader.js